<template>
  <el-row v-loading.fullscreen.lock="fullScreenLoading">
    <el-col
      :sm="{ span: 14, offset: 5 }"
      :md="{ span: 12, offset: 6 }"
      :lg="{ span: 12, offset: 6 }"
    >
      <el-header
        height="140px"
        class="app-header pt-50 pb-30"
      >
        <Menu />
        <h3 class="app-header-title mt-0">
          {{ businessEntity.name }}
        </h3>
        <h3 class="app-header-title truncate mt-0">
          {{ team.name }}
        </h3>
      </el-header>
      <el-main>
        <el-row class="filter mb-20">
          <p class="filter-title">
            {{ $t("teams.show-status") }}
          </p>
          <el-select
            v-model="filterStatus"
            class="filter-select"
            @change="filterQrCodes"
          >
            <el-option
              :label="$t('teams.status.all')"
              value="all"
            />
            <el-option
              :label="$t('teams.status.not-assigned')"
              value="Not assigned"
            />
            <el-option
              :label="$t('teams.status.assigned')"
              value="Assigned"
            />
            <el-option
              :label="$t('teams.status.waiting-confirm')"
              value="Waiting confirmation"
            />
          </el-select>
        </el-row>
        <el-collapse
          v-if="qrCodes"
          v-model="activeCollapse"
        >
          <el-collapse-item
            v-for="qrCode in filteredQrCodes"
            :key="qrCode.id"
            :class="getCollapseItemClass(qrCode.empStatus)"
          >
            <template slot="title">
              <div class="title">
                <p class="qrCode">
                  {{ qrCode.qrCode }}
                </p>
                <p class="type">
                  QR Code
                </p>
              </div>
            </template>
            <div
              class="rows-wrapper"
              v-if="!qrCode.empStatus || qrCode.empStatus === 'Not assigned'"
            >
              <div class="row">
                <span class="property">Status</span>
                <span
                  v-if="qrCode.empStatus"
                  class="value"
                >
                  {{
                    $t("teams.status." + qrCode.empStatus.kebabCase()) ||
                      $t("teams.status.not-assigned")
                  }}
                </span>
              </div>
            </div>
            <div
              class="rows-wrapper"
              v-else
            >
              <div class="row">
                <span
                  class="property"
                >{{ qrCode.name }} {{ qrCode.surName }}</span>
                <span class="value">
                  <img
                    :src="
                      `https://tippiie-images.s3.eu-central-1.amazonaws.com/public/${qrCode.photoUrl ||
                        'profile.png'}?t=${new Date().getTime()}`
                    "
                    :alt="qrCode.name"
                  >
                </span>
              </div>
              <div class="row">
                <span class="property">{{ $t("profile.phone") }}</span>
                <span class="value">{{ qrCode.phoneNum }}</span>
              </div>
              <div class="row">
                <span class="property">{{ $t("teams.create-date") }}</span>
                <span class="value">{{ formatDate(qrCode.created) }}</span>
              </div>
            </div>
            <el-row>
              <el-col
                class="mt-5"
                :lg="{ span: 11 }"
                :md="{ span: 11 }"
                :sm="{ span: 24 }"
                :xs="{ span: 24 }"
              >
                <el-button
                  type="default"
                  class="primary-outline-button"
                  @click="deleteQrCodeDialogVisible = true; qrCodeId = qrCode.id"
                >
                  {{ $t("teams.delete-qr-code") }}
                </el-button>
              </el-col>
              <el-col
                class="mt-5"
                :lg="{ span: 11, offset: 2 }"
                :md="{ span: 11, offset: 2 }"
                :sm="{ span: 24 }"
                :xs="{ span: 24 }"
              >
                <el-button
                  v-if="
                    !qrCode.empStatus || qrCode.empStatus === 'Not assigned'
                  "
                  type="success"
                  class="success-button"
                  @click="
                    assignEmployeeDialogVisible = true;
                    qrCodeId = qrCode.id;
                  "
                >
                  {{ $t("form.assign") }}
                </el-button>
                <el-button
                  v-else
                  type="primary"
                  class="primary-button"
                  @click="confirmUnassignDialogVisible = true; ; qrCodeId = qrCode.id"
                >
                  {{ $t("form.unassign") }}
                </el-button>
              </el-col>
            </el-row>
            <el-dialog
              :title="$t('form.unassign')"
              :visible.sync="confirmUnassignDialogVisible"
              width="330px"
              :center="true"
              :show-close="false"
              :append-to-body="true"
              class="confirm-dialog"
              @close="qrCodeId = ''"
            >
              <span class="confirm-dialog-title">
                {{
                  $t("form.confirm-unassign", {
                    company: businessEntity.name ,
                  })
                }}
              </span>
              <span slot="footer">
                <el-row>
                  <el-button
                    type="primary"
                    @click="unassignEmployee"
                    class="primary-button"
                  >
                    {{ $t("yes") }}
                  </el-button>
                </el-row>
                <el-row class="mt-20">
                  <el-button
                    type="text"
                    @click="confirmUnassignDialogVisible = false"
                    class="primary-link"
                  >
                    {{ $t("no") }}
                  </el-button>
                </el-row>
              </span>
            </el-dialog>
            <el-dialog
              title="Delete?"
              :visible.sync="deleteQrCodeDialogVisible"
              width="320px"
              :modal="false"
              :show-close="false"
              class="confirm-dialog"
              @close="qrCodeId = ''"
            >
              <span>{{ $t("organization.wanna-delete") }}</span>
              <span slot="footer">
                <el-row>
                  <el-button
                    type="primary"
                    @click="deleteQrCode"
                    class="primary-button"
                  >
                    {{ $t("yes") }}
                  </el-button>
                </el-row>
                <el-row class="mt-20">
                  <el-button
                    type="text"
                    @click="deleteQrCodeDialogVisible = false"
                    class="primary-link"
                  >
                    {{ $t("no") }}
                  </el-button>
                </el-row>
              </span>
            </el-dialog>
          </el-collapse-item>
        </el-collapse>
        <el-button
          type="primary"
          class="primary-button mb-10"
          @click="addQrCodeDialogVisible = true"
        >
          {{ $t("teams.add-qr") }}
        </el-button>
        <el-dialog
          :title="$t('teams.add-qr')"
          :visible.sync="addQrCodeDialogVisible"
          :show-close="false"
          width="320px"
          class="confirm-dialog"
          @close="qrCodeId = ''"
        >
          <span slot="footer">
            <el-form
              :model="addQrCodeForm"
              :rules="getAddQrCodeFormRules"
              ref="addQrCodeForm"
              label-position="top-left"
            >
              <el-form-item
                prop="name"
                label="QR Code"
              >
                <el-input v-model="addQrCodeForm.name" />
              </el-form-item>
              <el-form-item class="mt-10">
                <el-button
                  type="primary"
                  class="primary-button"
                  @click="submitForm('addQrCodeForm')"
                >
                  {{ $t("teams.create") }}
                </el-button>
              </el-form-item>
            </el-form>
          </span>
        </el-dialog>
        <el-dialog
          :title="$t('form.assign')"
          :visible.sync="assignEmployeeDialogVisible"
          :show-close="false"
          :modal="false"
          width="320px"
          class="confirm-dialog"
          @close="qrCodeId = ''"
        >
          <span slot="footer">
            <el-form
              :model="assignEmployeeForm"
              :rules="getAssignEmployeeFormRules"
              ref="assignEmployeeForm"
              label-position="top"
            >
              <el-form-item
                :label="$t('profile.phone')"
                prop="phone"
              >
                <vue-tel-input v-model="assignEmployeeForm.phone" />
              </el-form-item>
              <el-form-item class="mt-25">
                <el-button
                  type="primary"
                  class="primary-button"
                  @click="submitForm('assignEmployeeForm')"
                >
                  {{ $t("form.assign") }}
                </el-button>
              </el-form-item>
              <el-form-item class="mt-20">
                <el-button
                  type="text"
                  @click="assignEmployeeDialogVisible = false"
                  class="primary-link"
                >
                  {{ $t("no") }}
                </el-button>
              </el-form-item>
            </el-form>
          </span>
        </el-dialog>
      </el-main>
    </el-col>
  </el-row>
</template>

<script>
import Menu from "@/views/Menu/Menu";
import moment from "moment";

export default {
  name: "Team",
  components: {
    Menu,
  },
  data: () => ({
    fullScreenLoading: true,
    filterStatus: "all",
    team: {},
    activeCollapse: [],
    businessEntity: {},
    qrCodes: {},
    filteredQrCodes: {},
    addQrCodeDialogVisible: false,
    deleteQrCodeDialogVisible: false,
    assignEmployeeDialogVisible: false,
    confirmUnassignDialogVisible: false,
    addQrCodeForm: {
      name: "",
    },
    assignEmployeeForm: {
      phone: "",
    },
    qrCodeId: "",
  }),
  computed: {
    getAddQrCodeFormRules: function() {
      return {
        name: [
          {
            required: true,
            message: this.$t("form.validation.required", { field: "QR Code" }),
            trigger: "blur",
          },
        ],
      };
    },
    getAssignEmployeeFormRules: function() {
      return {
        phone: [
          {
            required: true,
            message: this.$t("form.validation.required", {
              field: this.$t("profile.phone"),
            }),
            trigger: "blur",
          },
        ],
      };
    },
  },
  created() {
    this.$adminApi
      .get("/api/v1/entities/" + this.$route.params.id)
      .then((response) => {
        this.businessEntity = response.data;
      });
    this.$adminApi
      .get("/api/v1/entities/teams/" + this.$route.params.teamId)
      .then((response) => {
        this.team = response.data;
        this.$axios
          .get("/api/v1/teams/" + this.$route.params.teamId + "/employees")
          .then((response) => {
            this.qrCodes = this.filteredQrCodes = response.data;
            this.fullScreenLoading = false;
          })
          .catch(() => {
            this.fullScreenLoading = false;
          });
      })
      .catch(() => {
        this.fullScreenLoading = false;
      });
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (formName === "assignEmployeeForm") {
            this.assignEmployee();
          } else if (formName === "addQrCodeForm") {
            this.addQrCode();
          }
        } else {
          return false;
        }
      });
    },
    getCollapseItemClass(status) {
      if (status === "Waiting confirmation") {
        return "unconfirmed";
      } else if (status === "Assigned") {
        return "confirmed";
      } else {
        return "not-assigned";
      }
    },
    filterQrCodes(value) {
      if (value === "all") {
        this.filteredQrCodes = this.qrCodes;
      } else {
        this.filteredQrCodes = this.qrCodes.filter((code) => {
          return code.empStatus === value;
        });
      }
    },
    formatDate(value) {
      return moment(value).format("DD.MM.YYYY");
    },
    addQrCode() {
      this.$adminApi
        .post(
          "/api/v1/entities/teams/" + this.$route.params.teamId + "/qrcode",
          {
            beUid: this.$route.params.id,
            teamUid: this.$route.params.teamId,
            representativeUid: this.businessEntity.representativeId,
            qrCode: this.addQrCodeForm.name,
          }
        )
        .then((response) => {
          if (response.data.status === "Success") {
            this.qrCodes.push(response.data.payload);
            this.addQrCodeForm.name = "";
            this.$message.success(
              this.$t("form.item-created", { item: "QR Code" })
            );
          } else {
            this.$message.warning(response.data.status);
          }
        })
        .catch((error) => {
          this.$message.error(error);
        });
    },
    deleteQrCode() {
      const currentId = this.qrCodeId
      this.$adminApi
        .delete("/api/v1/entities/teams/employees/" + currentId)
        .then((response) => {
          if (response.data.status === "Deleted") {
            this.qrCodes.splice(
              this.qrCodes.findIndex((code) => {
                return code.id === currentId;
              }),
              1
            );
            this.deleteQrCodeDialogVisible = false;
            this.activeCollapse = [];
            this.$message.success(
              this.$t("form.item-deleted", { item: "QR Code" })
            );
          }
        });
    },
    assignEmployee() {
      const currentId = this.qrCodeId
      this.$adminApi
        .put(
          "/api/v1/entities/teams/" + this.$route.params.teamId + "/employees",
          {
            id: currentId,
            representativeUid: this.businessEntity.representativeId,
            phoneNum: this.assignEmployeeForm.phone.replace(/[^\d.+]/g, ""),
          }
        )
        .then((response) => {
          this.assignEmployeeForm.phone = "";
          if (response.data.status === "Success") {
            this.$message.success(
              this.$t("form.item-assigned", { item: this.$t("teams.employee") })
            );
            this.assignEmployeeDialogVisible = false;
            this.$set(
              this.qrCodes,
              this.qrCodes.findIndex((el) => el.id === currentId),
              response.data.payload
            );
          } else {
            this.$message.warning(response.data.status);
          }
          this.qrCodeId = "";
        })
        .catch(() => {
          this.qrCodeId = "";
          this.$message.error(this.$t("form.something-wrong"));
        });
    },
    unassignEmployee() {
      const currentId = this.qrCodeId
      this.$adminApi
        .put("/api/v1/employees/" + currentId + "/unassign")
        .then((response) => {
          if (response.data.status === "Success") {
            this.$message.success(
              this.$t("form.item-unassigned", {
                item: this.$t("teams.employee"),
              })
            );
            this.$set(
              this.qrCodes,
              this.qrCodes.findIndex((el) => el.id === currentId),
              response.data.payload
            );
          } else {
            this.$message.warning(response.data.status);
          }
        })
        .catch(() => {
          this.$message.error(this.$t("form.something-wrong"));
        });

        this.confirmUnassignDialogVisible = false;
    },
  },
};
</script>

<style scoped lang="scss">
.filter {
  &-title {
    margin-bottom: 12px;
    font-family: "Raleway Medium", serif;
    font-size: 16px;
    color: #000000;
  }

  &-select::v-deep {
    width: 100%;

    input {
      color: #090a0a;
      border-radius: 8px;
      height: 48px;
    }
  }
}

.el-form-item {
  margin-bottom: 22px;
  text-align: left;
}
</style>
